export { default } from './svg/input-icon.svg';
